import moment from 'moment'
import { T, always, compose, cond, equals, head, pathOr, path } from 'ramda'
import { createMarkup } from 'features/common/elements/JobDetailSection/utils'
import { currencyFormatter, formatUnixDate } from '../../common/functions/formatters'

const formatCurrency = currencyFormatter()

const baseCompensation = pathOr(null, ['baseCompensation'])
const baseCompensationMax = pathOr(null, ['baseCompensationMax'])

const isBaseComp = job => baseCompensation(job) !== '0.00' && baseCompensation(job)
const isBaseCompMax = job => baseCompensationMax(job)

const JobStatsSalaryDataString = job => `${isBaseComp(job) ? formatCurrency(baseCompensation(job)) : ''}${isBaseComp(job) && isBaseCompMax(job) ? ' - ' : ''}${isBaseCompMax(job) ? formatCurrency(baseCompensationMax(job)) : ''} ${isBaseComp(job) || isBaseCompMax(job) ? getPayScheduleType(pathOr('', ['paySchedule'], job)) : ''}`

export const jobStatData = job => {
  if (job && !job.hideCompensation) {
    return [
      {
        title: `Salary`,
        data: isBaseComp(job) || isBaseCompMax(job) ? JobStatsSalaryDataString(job) : '',
        icon: 'dollar'
      },
      {
        title: `Total Anticipated Compensation Up To`,
        data: `${job.totalCompensation ? formatCurrency(job.totalCompensation) : ''}`,
        icon: 'dollar'
      }

    ]
  } else return []
}

export const getPayScheduleType = paySchedule => {
  if (paySchedule) {
    return cond([
      [equals('Hourly'), always('Per Hour')],
      [equals('Weekly'), always('Per Week')],
      [equals('Salary'), always('Per Year')],
      [T, always(`N/A`)]
    ])(paySchedule)
  } else return 'N/A'
}

export const getBaseCompensation = ({ baseCompensation, baseCompensationMax }) => {
  if (baseCompensation && baseCompensationMax) {
    return `${formatCurrency(baseCompensation)} - ${formatCurrency(baseCompensationMax)}`
  } else if (baseCompensation || baseCompensationMax) {
    return `${formatCurrency(baseCompensation || baseCompensationMax)}`
  } else return `N/A`
}

const getJobLocation = hit => {
  const city = pathOr(null, ['facilities', '0', 'city'], hit)
  const state = pathOr(null, ['facilities', '0', 'state'], hit)
  return city && state && `${city}, ${state}`
}

export const jobInformationData = (job) => {
  if (job) {
    return [
      { title: 'JOB ID:', children: pathOr('N/A', ['id'], job) },
      { title: 'LOCATION:', children: getJobLocation(job) },
      { title: 'JOB CATEGORY:', children: pathOr('N/A', ['jobCategory'], job) },
      {
        title: 'DATE POSTED:',
        children: formatUnixDate(job.createdAt)
      },
      {
        title: 'DEADLINE:',
        children: formatUnixDate(job.submissionDeadline)
      },
      { title: 'POSITION TYPE:', children: pathOr('N/A', ['employmentType'], job) },
      { title: 'EXPERIENCE:', children: `${pathOr('N/A', ['yearsExperience'], job)} years` },
      { title: 'EDUCATION REQUIRED:', children: pathOr([], ['education'], job).join('') },
      { title: 'ADDITIONAL PGA EDUCATION:', children: pathOr(null, ['additionalPGAEducation'], job) },
      { title: 'ADDITIONAL INCOME:', children: createMarkup(job, 'additionalIncome') }
    ].filter(item => item.children)
  } else return []
}

export const jobAdditionalData = job => {
  if (job) {
    return [
      { title: 'Overview', children: job.overview },
      { title: 'Experience Required', children: job.experienceRequired },
      { title: 'Essential Responsibilities', children: job.responsibilities },
      { title: 'Benefits', children: job.benefits }
    ].filter(item => item.children)
  } else return []
}

export const jobOfficeName = compose(pathOr('N/A', ['name']), head(), pathOr([], ['offices']))

export const isPgaProApplicantGroup = (job = {}) => pathOr('', ['applicantGroup'], job) === 'PGA Professional Only'

export const isInternshipApplicantGroup = data =>
  pathOr(null, ['job', 'applicantGroup'], data) === 'PGA Golf Management University Internship'

export const isValidDeadline = (job = {}) => moment(moment.unix(job.submissionDeadline)).isAfter(moment())

export const getFacilityUrl = path(['job', 'website'])
